import { render, staticRenderFns } from "./CardVerifiedApp.vue?vue&type=template&id=ddd01986&scoped=true"
import script from "./CardVerifiedApp.vue?vue&type=script&lang=js"
export * from "./CardVerifiedApp.vue?vue&type=script&lang=js"
import style0 from "./CardVerifiedApp.vue?vue&type=style&index=0&id=ddd01986&prod&lang=css"
import style1 from "./CardVerifiedApp.vue?vue&type=style&index=1&id=ddd01986&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddd01986",
  null
  
)

export default component.exports